import React, { useState } from "react";
import moment from "moment";
import { BsPlusLg } from "react-icons/bs";
import { BiMinus } from "react-icons/bi";
import TableHeader from "components/common/Table/TableHeader";
import AvatarGroup from "components/common/Avatar/AvatarGroup";
import _ from "lodash";
import DataDisplayModal from "../DataDisplayModal";

const TimesheetSubTable = (props) => {
  const { item } = props;
  const [expandedRows, setExpandedRows] = React.useState([]);
  const [modalData, setModalData] = useState(null);
  const [workerORParticipant, setWorkerORParticipant] = useState(null);
  const [Label, setLabel] = useState(null);
  const [openModel, setOpenModal] = useState(false);
  const handleRowClick = (index) => {
    const newExpandedRows = [...expandedRows];
    if (expandedRows.includes(index)) {
      const indexToRemove = newExpandedRows.indexOf(index);
      newExpandedRows.splice(indexToRemove, 1);
    } else {
      newExpandedRows.push(index);
    }

    setExpandedRows(newExpandedRows);
  };
  const handleclose = () => {
    setOpenModal(false);
  };
  return (
    <>
      <tr className='text-center even:bg-white odd:bg-gray-50'>
        <td
          className='flex justify-center items-center h-[50px]  cursor-pointer'
          onClick={() => handleRowClick(item.uuid)}
        >
          <div className='flex align-center cursor-pointer '>
            {expandedRows.includes(item.uuid) ? (
              <BiMinus className='mt-1 text-gray-600' />
            ) : (
              <BsPlusLg className='h-3 w-3 mt-1 text-gray-600' />
            )}
          </div>
        </td>

        <td className=' w-[120px] px-3 text-sm text-gray-500'>
          <div>
            {(item?.participants && _.isArray(item?.participants) && (
              <AvatarGroup
                type='participant'
                arrayData={item?.participants || []}
                cssClass='mt-0 '
                maxLength={4}
              />
            )) ||
              "-"}
          </div>
        </td>
        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
          {`${item?.worker?.first_name} ${item?.worker?.last_name}`}
        </td>
        <td className='px-3 text-left py-[11px] text-sm text-gray-500'>
          {item?.time_sheet_date
            ? moment(item.time_sheet_date).format("DD/MM/YYYY")
            : "-"}
        </td>
        <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
          {item?.start_time ? item?.start_time : "N/A"}
        </td>
        <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
          {item?.end_time ? item?.end_time : "N/A"}
        </td>

        <td className='px-3 text-left text-sm text-gray-500'>
          {item.timesheet_length || "-"}
        </td>
        <td className='px-3 text-left text-sm text-gray-500 capitalize'>
          {item.status || "-"}
        </td>

        <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
          <div
            onClick={() => {
              setOpenModal(true);
              setLabel("Shift Notes");
              setWorkerORParticipant(item?.participants);
              setModalData(item?.shift_notes);
            }}
            tabIndex={0}
            role='button'
            className=' underline text-blue-400 hover:text-blue-700'
          >
            View
          </div>
        </td>
        <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
          <div
            onClick={() => {
              setOpenModal(true);
              setLabel("Incidents");
              setWorkerORParticipant(item?.participants);

              setModalData(item?.incident);
            }}
            tabIndex={0}
            role='button'
            className=' underline text-blue-400 hover:text-blue-700'
          >
            View
          </div>
        </td>
        <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
          {item?.km || 0}
        </td>
        <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
          <div
            onClick={() => {
              setOpenModal(true);
              setLabel("Shift Associated Cost $");
              setWorkerORParticipant(item?.participants);

              setModalData(item?.comment);
            }}
            tabIndex={0}
            role='button'
            className=' underline text-blue-400 hover:text-blue-700'
          >
            View
          </div>
        </td>
      </tr>

      {expandedRows.includes(item.uuid) && (
        <tr className='text-center '>
          <td colSpan={12} className='px-3 py-4'>
            <table className='min-w-full divide-y divide-gray-300 border'>
              <thead>
                <tr>
                  <TableHeader isSort={false} label={"Start Time"} />

                  <TableHeader isSort={false} label={"End Time"} />

                  <TableHeader isSort={false} label={"Duration"} />

                  <TableHeader isSort={false} label={"Service Type Name"} />

                  <TableHeader
                    isSort={false}
                    label={"NDIS Support Item Number"}
                  />

                  <TableHeader
                    isSort={false}
                    label={"NDIS Support Item Name"}
                  />
                </tr>
              </thead>
              <tbody className='divide-y divide-gray-200 bg-whit'>
                {item?.invoiceTimesheets &&
                item?.invoiceTimesheets?.length > 0 ? (
                  item?.invoiceTimesheets?.map((timesheet, index) => (
                    <tr key={index} className='even:bg-white odd:bg-gray-50'>
                      <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                        {timesheet?.start_time
                          ? moment(timesheet?.start_time).format(
                              "DD/MM/YYYY hh:mm:ss A"
                            )
                          : "N/A"}
                      </td>
                      <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                        {timesheet?.end_time
                          ? moment(timesheet?.end_time).format(
                              "DD/MM/YYYY hh:mm:ss A"
                            )
                          : "N/A"}
                      </td>

                      <td className='px-3 text-left text-sm text-gray-500'>
                        {timesheet.duration || "-"}
                      </td>
                      <td className='px-3 text-left text-sm text-gray-500 capitalize'>
                        {timesheet.service_type_name || "-"}
                      </td>
                      <td className='px-3 text-left text-sm text-gray-500 capitalize'>
                        {timesheet.ndis_support_item_number || "-"}
                      </td>
                      <td className='px-3 text-left text-sm text-gray-500 capitalize'>
                        {timesheet.ndis_support_item_name || "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={10}
                      className='py-6 text-sm text-center text-red-600'
                    >
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      )}

      {openModel && (
        <DataDisplayModal
          openModel={openModel}
          handleClose={handleclose}
          title='Timesheet Report'
          data={modalData}
          Participant={workerORParticipant}
          Label={Label}
        />
      )}
    </>
  );
};

export default TimesheetSubTable;
